export default {
    GET_ROUTE (state) {
        return state.route;
    },
    GET_DRAWER (state) {
        return state.drawer;
    },
    GET_LOADING (state) {
        return state.loading
    },
    GET_PAGE_LOADING (state) {
        return state.page_loading
    },
    GET_USER (state) {
        return state.user
    },
    GET_ALERT (state) {
        return state.alert
    },
    GET_AUTHORIZATION (state) {
        return state.authorization
    },
    GET_COLUMNS (state) {
        return state.columns
    },
    GET_SETUP (state) {
        return state.setup
    },
    GET_CLEANING_DIALOG_STATUS (state) {
        return state.cleaning_dialog_status
    }
}
